export default __webpack_public_path__ + "static/media/placeholder.87cd0710.jpg";